import * as yup from 'yup';
import { DateTime } from 'luxon';
import { eInternalOrderStatus } from '../../../enums/eInternalOrderStatus';
import { ISelectOption } from '../../../components';
import { eCurativeGrade } from '../../../enums/eCurativeGrade';
import { eUSAState } from '../../../enums/states';
import { eTransactionCategory } from '../../../enums/eTransactionType';
import { eExternalOrderStatus } from '../../../enums/eExternalOrderStatus';
import { eServices } from '../../../enums/eServices';
import { isNil } from 'lodash';

export const searchOrdersSpecification = (lenders: ISelectOption[], clients: ISelectOption[]) =>
  yup.object().shape({
    fileNumbers: yup.array().of(yup.string()).nullable(),
    createdAtStart: yup
      .string()
      .test(
        'createdAtStart',
        'Enter a valid date',
        (value: string | null | undefined) => value === null || value === undefined || DateTime.fromISO(value).isValid
      )
      .nullable(),
    createdAtEnd: yup
      .string()
      .test(
        'createdAtEnd',
        'Enter a valid date',
        (value: string | null | undefined) => value === null || value === undefined || DateTime.fromISO(value).isValid
      )
      .nullable(),
    closingDateStart: yup
      .string()
      .test(
        'closingDateStart',
        'Enter a valid date',
        (value: string | null | undefined) => value === null || value === undefined || DateTime.fromISO(value).isValid
      )
      .nullable(),
    closingDateEnd: yup
      .string()
      .test(
        'closingDateEnd',
        'Enter a valid date',
        (value: string | null | undefined) => value === null || value === undefined || DateTime.fromISO(value).isValid
      )
      .nullable(),
    partyName: yup.string().nullable(),
    loanNumber: yup.string().nullable(),
    bulkId: yup.string().nullable(),
    streetAddress: yup.string().nullable(),
    unit: yup.string().nullable(),
    zipCode: yup.string().length(5).nullable(),
    city: yup.string().nullable(),
    countyId: yup.string().nullable(),
    state: yup.mixed<eUSAState>().nullable(),
    curativeGrades: yup.array().of(yup.mixed<eCurativeGrade>()).nullable(),
    transactionCategory: yup.mixed<eTransactionCategory>().nullable(),
    lenderCompanyIds: yup
      .array()
      .of(yup.string())
      .test('lenderCompanyIds', 'Enter a valid lender', (values?: (string | null | undefined)[]) => {
        return values
          ? !values.map((value) => !!lenders.find((lender) => lender.value === value)).includes(false)
          : isNil(values);
      })
      .nullable(),
    clientCompanyIds: yup
      .array()
      .of(yup.string())
      .test('clientCompanyIds', 'Enter a valid lender', (values?: (string | null | undefined)[]) =>
        values
          ? !values.map((value) => !!clients.find((client) => client.value === value)).includes(false)
          : isNil(values)
      )
      .nullable(),
    statuses: yup.array().of(yup.mixed<eInternalOrderStatus>()).nullable(),
    services: yup.array().of(yup.mixed<eServices>()).nullable(),
    externalStatuses: yup.array().of(yup.mixed<eExternalOrderStatus>()).nullable(),
    sortBy: yup.string().nullable(),
    pageNumber: yup.number().min(0).integer().nullable(),
    pageSize: yup.number().min(0).integer().nullable(),
  });
